import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'sn-usc-bi',
    templateUrl: './usc-bi.component.html',
    styleUrls: ['./usc-bi.component.css']
})
export class UscBiComponent implements OnInit {

    constructor() { }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-bi/usc-bi.component.ts